import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../constants';
import { Header } from '../components/home/Header';
import { HeroSection } from '../components/home/HeroSection';
import { ServicesSection } from '../components/home/ServicesSection';
import { GallerySection } from '../components/home/GallerySection';
import { BookingSection } from '../components/home/BookingSection';
import { PricingSection } from '../components/home/PricingSection';
import { ReviewsSection } from '../components/home/ReviewsSection';
import { FAQSection } from '../components/home/FAQSection';
import { ContactSection, Footer } from '../components/home/ContactFooter';
import { WhatsAppWidget, AIChatbot, CookieConsent } from '../components/home/Widgets';

const HomePage = () => {
  const [lightSettings, setLightSettings] = useState({
    enabled: true,
    speed: 'normal',
    intensity: 'medium'
  });
  const [aiChatbotEnabled, setAiChatbotEnabled] = useState(false);

  useEffect(() => {
    const trackVisit = async () => {
      try {
        await axios.post(`${API}/track-visit`, { page: '/' });
      } catch (error) {}
    };
    
    const fetchSettings = async () => {
      try {
        const response = await axios.get(`${API}/settings`);
        setLightSettings({
          enabled: response.data.light_effect_enabled ?? true,
          speed: response.data.light_effect_speed ?? 'normal',
          intensity: response.data.light_effect_intensity ?? 'medium'
        });
        setAiChatbotEnabled(response.data.ai_chatbot_enabled ?? false);
      } catch (error) {}
    };

    const injectSchema = async () => {
      try {
        const [localBiz, faqSchema, servicesSchema] = await Promise.all([
          axios.get(`${API}/schema/local-business`),
          axios.get(`${API}/schema/faq`),
          axios.get(`${API}/schema/services`),
        ]);
        const schemas = [localBiz.data, faqSchema.data, servicesSchema.data];
        schemas.forEach((schema, i) => {
          const id = `schema-jsonld-${i}`;
          if (!document.getElementById(id)) {
            const script = document.createElement('script');
            script.id = id;
            script.type = 'application/ld+json';
            script.textContent = JSON.stringify(schema);
            document.head.appendChild(script);
          }
        });
      } catch (error) {}
    };
    
    trackVisit();
    fetchSettings();
    injectSchema();

    return () => {
      [0, 1, 2].forEach(i => {
        const el = document.getElementById(`schema-jsonld-${i}`);
        if (el) el.remove();
      });
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#05050A]">
      <Header />
      <main>
        <HeroSection lightSettings={lightSettings} />
        <ServicesSection />
        <GallerySection />
        <BookingSection />
        <PricingSection />
        <ReviewsSection />
        <FAQSection />
        <ContactSection />
      </main>
      <Footer />
      <WhatsAppWidget />
      <AIChatbot enabled={aiChatbotEnabled} />
      <CookieConsent />
    </div>
  );
};

export default HomePage;
